import moment from 'moment'
import isObject from 'isobject'
import toBool from 'fn/toBool'
import validator from 'fn/validator'

class Schema {
  constructor( schema, name, names ) {
    if ( ! isObject( schema ) )
      throw 'schema must be an object'

    const it = this

    it._schema = schema

    return it
  }

  validate( item, skipRequired = false ) {
    const it = this
    const __schema = { ...it._schema }

    if ( skipRequired )
      __schema.required = []

    const validate = validator.compile( __schema )

    return new Promise( ( resolve, reject ) => {
      const isValid = validate( item )
      if ( isValid )
        return resolve()

      return reject( validate.errors )
    } )
  }

  defaults( item ) {
    const it = this

    Object
      .keys( it._schema.properties )
      .forEach( p => {
        const v = it._schema.properties[ p ]

        if ( [ null, undefined ].indexOf( v.default ) > 0 )
          return

        if ( [ null, undefined ].indexOf( item[ p ] ) !== -1 ) {
          let value = v.default

          if ( typeof v.default === 'function' )
            value = v.default()

          item[ p ] = value
        }
      } )

    return item
  }

  castField( item, key ) {
    const it = this

    const { type, format } = it._schema.properties[ key ] || {}

    if ( ! type && ! format )
      throw `property '${ key }' is not defined on schema`

    const value = item[ key ]

    switch( type ) {
      case 'number':
        return Number( value ).valueOf()

      case 'boolean':
        return toBool( value )

      case 'string':
        if ( ! value )
          return undefined

        switch( format ) {
          case 'date-time':
            return moment( value ).toISOString()
          default:
            return String( value ).valueOf()
        }
    }
  }

  cast( item ) {
    const it = this

    return Object
      .keys( item )
      .filter( k => it._schema.properties[ k ] )
      .map( k => {
        return {
          [ k ]: it.castField( item, k )
        }
      } )
      .reduce( ( acc, cur ) => ( {
        ...acc,
        ...cur
      } ), {} )
  }

  get() {
    return this._schema
  }
}

export default Schema
